<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;margin-top: 1rem;" class="fontMS700 font-45 colorPrincipal">
            RECUERDO DE LA MONARQUÍA PERUANA Ó<br>
            BOSQUEJO DE LA HISTORIA DE LOS INCAS.<br>
        
        <span class="fontMS100 font-45 colorPrincipal">
            MANUSCRITO DE SAHUARAURA, JUSTO APU<br>
            (CUZCO 1770 – ¿?)
        </span></p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio28/justo-sahuaraura">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio28/justo-sahuaraura">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio28/justo-sahuaraura">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" style="margin-top: 6rem;"  src="/assets/images/micrositio/micrositio28/JUSTO-000.jpg">
    
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <p>
                        <br><br>
                    </p>
                    <div class="c100">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio28/JUSTO-LINEA-000.png">
                    </div>
                    <div class="col-sm-3">
                        <p style="line-height: 200%;margin-bottom: 0%;" class="fontMS700 colorPrincipal font-40 text-center">
                            EL AUTOR
                        </p>
                    </div>
                    <div class="col-sm-9">
                        <img class="LineSubsec_Izq bottom_cel" width="100%" style="margin-top: 5%;"
                            src="/assets/images/micrositio/micrositio28/JUSTO-LINEA-000.png">
                    </div>
                </div>
                <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS100 colorPrincipal font-40">
                    
                </p>
                <div class="c100">
                    <img class="LineSubsec_Izq" width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-LINEA-000.png">
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS500 text-center font-24">
                            <br><br>
                            JUSTO APU SAHUARAURA FUE UN DISTINGUIDO CLÉRIGO QUE FORMÓ PARTE DE 
                            LA NOBLEZA INDÍGENA DEL CUZCO.
                            COMO NOBLE E HIJO DE CACIQUE, INICIÓ SUS ESTUDIOS EN EL COLEGIO DE 
                            INDIOS NOBLES SAN FRANCISCO DE BORJA. CURSÓ TEOLOGÍA Y DERECHO 
                            CANÓNIGO EN LA UNIVERSIDAD SAN ANTONIO DE ABAD. GRADUADO DE DOCTOR 
                            FUE DESTACADO A LA PARROQUIA DE SORAYA, DE LA PROVINCIA DE AYMARAES 
                            (APURÍMAC).

                            <br><br>
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6 libro ">
                        
                        <p class="bottom_cel">
                            <br><br>
                        </p>
                        <img  class=" Text-left" width="100%"
                                    src="/assets/images/micrositio/micrositio28/JUSTO-001.jpg">

                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS500Italic font-20 pi-10 mt6" >
                            <br><br>
                            Retrato de Justo Sahuaraura, Cuzco, ca. 1836. Óleo <br>
                            sobre lienzo. Museo Histórico Regional, Cuzco.<br><br>
                            Reproducido en: Natalia Majluf. “De la rebelión al <br>
                            museo: Genealogías y retratos de los incas, 1781-1900”
                            <br><br>
                        </p>
                    </div>
                    
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS100 text-justify font-24 ">
                            <br><br>
                            Por su participación en momentos importantes del proceso emancipador del Perú, 
                            se le reconoce como prócer de la Patria. Su apoyo a la defensa de la causa 
                            independentista y el uso de su patrimonio para financiar la revolución de los 
                            hermanos Ángulo y Mateo Pumacahua en 1814, le valió la cárcel. Fue destituido 
                            de su cargo y sus propiedades fueron saqueadas e incendiadas. Posteriormente, 
                            se une al ejército patriota que llega a Apurímac y uniéndose a sus filas se 
                            enrumbó con ellos hasta Ayacucho. En reconocimiento a su cooperación, la joven 
                            república ya independiente, lo nombra como uno de sus “hijos predilectos” y en 
                            1826 fue declarado diputado por Aymaraes, entre otros prestigiosos nombramientos.
                            
                        </p>
                    </div>
                    <div class="col-sm-6 libro">
                        <p class="bottom_cel">
                            <br><br>
                        </p>
                        <a href="https://hdl.handle.net/20.500.14428/61493" target="_blank" style="color: black;">
                            <img class="pi-10 pd-10" width="100%"
                                    src="/assets/images/micrositio/micrositio28/JUSTO-002.JPG">
                        </a>
                        <p class="fontMS100Italic pi-10 font-20">
                            <br>
                            &nbsp;&nbsp; Objeto. Grabado. Justo Sahuaraura 
                        </p>
                    </div>
                </div>
                <hr />
                <div class="row mt-5">
                    
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-24 ">
                            <br><br>
                            Tras la independencia peruana, la noble aristocracia indígena perdió los 
                            privilegios que obtuvieron durante el virreinato en el marco de las alianzas 
                            establecidas con el régimen monárquico. 
                            Como parte de este grupo social ya debilitado, Sahuaraura emprende la tarea 
                            de estudiar a sus antepasados Incas y su cultura. Orgulloso de su estirpe y, 
                            quizá, con el firme deseo de fortalecer y promover el reconocimiento histórico 
                            de sus ancestros escribe su obra: “RECUERDO DE LA MONARQUÍA PERUANA ó BOSQUEJO 
                            DE LA HISTORIA DE LOS INCAS”, que incluye una serie de acuarelas con los retratos 
                            individuales de todos los incas.

                            <br><br>
                        </p>

                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/64467" target="_blank" style="color: black;">
                            <img width="100%"
                            src="/assets/images/micrositio/micrositio28/JUSTO-003.jpg">
                        </a>
                    </div>
                    <div class="col-sm-5 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/64467" target="_blank" style="color: black;">
                            <img width="100%"
                            src="/assets/images/micrositio/micrositio28/JUSTO-004.png">
                        </a>
                        <p class="fontMS500Italic fw-bolder font-20 text-gris">
                            <br>
                            &nbsp;&nbsp;Recuerdo de la monarquía peruana ó <br>
                            &nbsp;&nbsp;bosquejo de la historia de los incas
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    LAS REPRESENTACIONES
                </p>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS100 text-center colorPrincipal font-40">
                            DE LOS INCAS
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-sm-6 ">
                        <p class="bottom_cel">
                            <br><br>
                        </p>
                        <div class="col-sm-12 ma-5">
                            <img  class=" Text-left" width="100%"
                            src="/assets/images/micrositio/micrositio28/JUSTO-005.jpg">
                        </div>
                        
                        <div class="col-sm-12">
                            <p class="fontMS100 text-white font-20 ">
                                <br>
                                Disponible en: Colección: Biblioteca Nacional de Chile. <br>
                                Códigos BN: MC0012407. N° sistema: 71938
                             </p>
                        </div>
                    </div>
                    
                    <div class="col-sm-6 ">
                        <p class="fontMS100Italic text-white font-24 ">
                            <br><br><br>
                            La representación de los incas durante la colonia fue una práctica 
                            que surgió por el interés de dar a conocer en Europa los sucesos 
                            ocurridos durante la conquista, así como los procesos de colonización 
                            hispánica de América. Tal es el caso del texto histórico que, a un 
                            siglo de la conquista, publica Antonio de Herrera y Tordesillas bajo 
                            el título de “Historia general de los hechos de los castellanos en 
                            las Islas y Tierra Firme del mar Océano que llaman Indias Occidentales”. 
                            Posteriormente circuló, desde la oficialidad, una estampa ideada por Alonso 
                            de la Cueva, donde se ve una sucesión de autoridades incas, seguidas por 
                            las figuras de los monarcas españoles, estableciendo una normal y armónica 
                            continuidad en la línea de transmisión del poder en las nuevas tierras de 
                            la Corona Española.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-12">
                        <p class="bottom_cel">
                            <br><br>
                        </p>
                        <img  class=" Text-left" width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-006.jpg">
                        <p class="fontMS100 text-white font-24 ">
                            <br>
                            Reproducido en: Banco de Crédito del Perú (2005) Los Incas, Reyes del Perú . Colección Arte y Tesoros del <br>
                            Perú. Lima, Banco de Crédito del Perú. Pag. 233
                            <br>
                        </p>
                        <p class="bottom_cel">
                            <br><br>
                        </p>
                        <hr class=" text-white"/>
                    </div>
                    <div class="col-sm-12">
                        <p class="bottom_cel">
                            <br><br>
                        </p>
                        <p class="fontMS100 text-white font-24 text-justify">
                            Por su parte, los descendientes directos del linaje Inca, recurrieron a 
                            esta representación para legitimar su noble ascendencia y ganar privilegios. 
                            Sin embargo, en su propia interpretación, algunos eliminaron la sucesión de 
                            los monarcas españoles, dejando solo a la dinastía de los incas como los 
                            protagonistas en sus pinturas. Crónicas de la época hacen referencia a pinturas 
                            de esta sucesión de incas en las residencias de los principales curacas. 
                            Sin embargo, no han llegado hasta nosotros la misma proporción de ejemplares 
                            de esa composición pues, luego de la derrota de la rebelión acaudillada por Tupac 
                            Amaru (1780), las autoridades españolas ordenaron destruir todas aquellas 
                            representaciones y demás objetos simbólicos de la sociedad inca como los queros. 
                            Desmantelar todo lo que aludía al pasado indígena y sus tradiciones culturales fue el objetivo.
                            <br><br>
                        </p>
                        <p class="bottom_cel">
                            <br>
                        </p>
                        <img  class=" Text-left" width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-007.jpg">
                    </div>
                    <p class="fontMS100Italic text-white font-24 ">
                        <br>
                        Genealogía de los Incas, Cuzco, ca. 1835-1845. Óleo sobre <br>
                        lienzo, 102,9 x 102,9 cm. Museo Pedro de Osma, Lima
                        <br><br>
                    </p>

                </div>
                
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12 mt-5">
                <div class="row">
                    <div class="c100">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio24/E03-MS08-GRAMA_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-3">
                        <p style="line-height: 250%;margin-bottom: 0%;margin-top:5%" class="fontMS700 colorPrincipal font-40 text-center">
                            LA OBRA
                        </p>
                    </div>
                    <div class="col-sm-9">
                        <img class="LineSubsec_Izq bottom_cel" width="100%" style="margin-top: 7%;"
                            src="/assets/images/micrositio/micrositio24/E03-MS08-GRAMA_LINEA1-recortada2.png">
                    </div>
                </div>
                <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS100 colorPrincipal font-40">
                    
                </p>
                <div class="c100">
                    <img class="LineSubsec_Izq" width="100%"
                        src="/assets/images/micrositio/micrositio24/E03-MS08-GRAMA_LINEA1-recortada2.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br><br>
                    LA LABORIOSA INVESTIGACIÓN DE JUSTO APU SAHUARAURA SE CONCRETÓ EN UN MANUSCRITO Y UN 
                    LIBRO IMPRESO: DOS VERSIONES CON VARIANTES DE UN MISMO DOCUMENTO. EL MATERIAL QUE 
                    POSEE LA BIBLIOTECA NACIONAL DEL PERÚ ES EL MANUSCRITO QUE CUENTA CON 17 ACUARELAS. 
                    ESTE ORIGINAL ES MUY VALIOSO PARA LA HISTORIOGRAFÍA PERUANA, PUES EN ÉL SE NARRAN A 
                    DETALLE LOS PRINCIPALES HECHOS DEL PERIODO DE LA CONQUISTA DEL PERÚ; LUEGO DE ESTE 
                    PREÁMBULO HISTÓRICO, NUESTRO PERSONAJE AHONDA EN LA GENEALOGÍA DE LOS INCAS PARA 
                    FINALMENTE, DEMOSTRAR CON REFERENCIAS DOCUMENTALES, SU LÍNEA DE PARENTESCO DIRECTO 
                    CON PAULLO INCA, HIJO DE HUAYNA CAPAC.
                    <br><br>
                </p>

                <div class="row">
                    <div class="col-sm-4"></div>
                    <div class="col-sm-4">
                        <img class="text-center" width="100%"
                            src="/assets/images/micrositio/micrositio28/JUSTO-008.jpg">
                    </div>
                    <div class="col-sm-4"></div>

                </div>

                <div class="row" style="margin-top: 15%;">
                    
                    <div class="col-sm-3 ">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LAS ACUARELAS Y SUS
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS100 text-center colorPrincipal font-40">
                            FUENTES DE REFERENCIA
                        </p>
                </div>

                <p class="fontMS500 text-center font-24">
                    <br><br>
                    LAS 17 ACUARELAS QUE INTEGRAN ESTE MANUSCRITO SON LOS RETRATOS DE LOS GOBERNANTES INCAS, 
                    DESDE MANCO CÁPAC HASTA TUPAC AMARU; CADA UNO DE ELLOS ESTÁ ACOMPAÑADO POR UN TEXTO QUE 
                    RELATA SUS RESPECTIVAS LÍNEAS DE PARENTESCO, ENUMERA SU DESCENDENCIA Y SEÑALA LA 
                    DENOMINACIÓN DE CADA PANACA.
                    <br><br>
                </p>
                <p class="fontMS100 text-justify font-24">
                    Estas acuarelas están inspiradas en los retratos de los incas que aparecen en el mencionado 
                    grabado para la Historia general de los hechos de los castellanos en las Islas y Tierra 
                    Firme del mar Océano que llaman Indias Occidentales (1610-1615). Salvo mínimas variantes, 
                    las 13 primeras acuarelas del manuscrito de Sahuaraura son una fiel reproducción de las 
                    imágenes de la estampa. Las 4 acuarelas adicionales de los últimos incas de la dinastía, 
                    que no están presentes en el grabado citado, fueron elaboradas siguiendo el mismo estilo 
                    pictórico. Cabe señalar que en la genealogía de Sahuaraura no incluye a Atahualpa, a quien 
                    consideró un traidor.
                    <br><br>
                    Siguiendo como modelo la misma estampa de Antonio de Herrera, y de manera mucho más exacta, 
                    existe una serie de oleos que también reproducimos por su vinculación a las acuarelas del 
                    manuscrito custodiado por la BNP. Estos  óleos de la escuela cuzqueña, de mediados del 
                    siglo XVIII, forman parta de la colección del Museo de Brooklyn, Nueva York, EE. UU.  
                    <br><br>
                    Conviene señalar que el uso de los grabados, como fuente iconográfica, fue una práctica muy 
                    generalizada durante la colonia. Ya que los artistas de entonces, usaron las estampas como 
                    modelos artisticos para el desarrollo de su arte.
                    <br><br>
                </p>

                <hr class="text-white"/>
                <br><br>
                <div class="row mt-5">
                    <div class="col-sm-4 mt-3">
                        <hr/>
                    </div>
                    
                    <div class="col-sm-4">
                        <p style="line-height: 120%;margin-bottom: 0%; color: #808080;"
                            class="fontMS700 text-center font-40">
                            ACUARELA
                        </p>
                    </div>
                    
                    <div class="col-sm-4 mt-3">
                        <hr/>
                    </div>
                </div>

                <p class="fontMS500 text-center font-24 mt-5">
                    <br>
                    RECUERDO DE LA MONARQUÍA PERUANA Ó BOSQUEJO <br>
                    DE LA HISTORIA DE LOS INCAS
                </p>
            </div>
        </div>
    </div>

    <div class="container">

    <div class="row">
        <!--Fila 1 -->
            <div class="col-sm-3 mt-2 libro">
                <a target="_blank" href="http://hdl.handle.net/20.500.14428/79579">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-009.jpg">
                </a>
            </div>
            <div class="col-sm-3 mt-2 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/52/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-010.jpg">
                </a>
            </div>
            <div class="col-sm-3 mt-2 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/54/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-011.jpg">
                </a>
            </div>
            <div class="col-sm-3 mt-2 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/56/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-012.jpg">
                </a>
            </div>

        <!--Fila 2 -->
            <div class="col-sm-3 mt-4 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/58/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-013.jpg">
                </a>
            </div>
            <div class="col-sm-3 mt-4 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/60/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-014.jpg">
                </a>
            </div>
            <div class="col-sm-3 mt-4 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/62/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-015.jpg">
                </a>
            </div>
            <div class="col-sm-3 mt-4 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/64/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-016.jpg">
                </a>
            </div>

        <!--Fila 3 -->
            <div class="col-sm-3 mt-4 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/66/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-017.jpg">
                </a>
            </div>
            <div class="col-sm-3 mt-4 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/68/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-018.jpg">
                </a>
            </div>
            <div class="col-sm-3 mt-4 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/70/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-019.jpg">
                </a>
            </div>
            <div class="col-sm-3 mt-4 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/72/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-020.jpg">
                </a>
            </div>

        <!--Fila 4 -->
            <div class="col-sm-3 mt-4 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/74/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-021.jpg">
                </a>
            </div>
            <div class="col-sm-3 mt-4 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/76/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-022.jpg">
                </a>
            </div>
            <div class="col-sm-3 mt-4 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/78/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-023.jpg">
                </a>
            </div>
            <div class="col-sm-3 mt-4 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/80/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-024.jpg">
                </a>
            </div>

        <!--Fila 5 -->
            <div class="col-sm-3 mt-4 libro">
                <a target="_blank" href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-la-monarquia-peruana-o-bosquejo-de-la-historia-de-los-incas/82/">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-025.jpg">
                </a>
            </div>
            <div class="col-sm-3 mt-4 libro">
            </div>
            <div class="col-sm-3 mt-4 libro">
            </div>
            <div class="col-sm-3 mt-4 libro">
            </div>
    </div>
    </div>

    <div class="container">
        <div class="row marg">
            <div class="col-sm-12 mt-4">
                <div class="row mt-5">
                    <div class="col-sm-4 mt-3">
                        <hr/>
                    </div>
                    
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%; color: #808080;"
                            class="fontMS700 text-center font-40">
                            GRABADO
                        </p>
                    </div>
                    
                    <div class="col-sm-4 mt-3">
                        <hr/>
                    </div>
                </div>
            </div>
        </div>
        <p class="fontMS100 text-justify font-24 mt-4 " style="padding-left: 2%;padding-right: 2%;">
            
            Historia general de los hechos de los castellanos en las Islas i tierra firme del mar 
            Océano que llaman Indias Occidentales, escrita por Antonio de Herrera. Madrid: En la 
            Impr. Real, por Juan Flmenco, 1601-1615. 4v.paña. Impreso por Juan de la Cuesta, 
            Madrid, 1615.Disponible en:
            <br>
            <span class=" font-20 " style="word-wrap: break-word;">
            Colección: Biblioteca Nacional de Chile. Códigos BN: MC0012407. N° sistema: 71938<br>
            <a target="_blank" class="text-dark" href="http://www.memoriachilena.gob.cl/602/w3-article-8395.html">
            http://www.memoriachilena.gob.cl/602/w3-article-8395.html
            </a></span>
        </p>
    </div>

    <div class="container">
    <div class="row ">
        <!--Fila 1 -->
            <div class="col-sm-3 mt-3 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-026.jpg">
              
            </div>
            <div class="col-sm-3 mt-3 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-027.jpg">
                
            </div>
            <div class="col-sm-3 mt-3 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-028.jpg">
                
            </div>
            <div class="col-sm-3 mt-3 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-029.jpg">
                
            </div>

        <!--Fila 2 -->
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-030.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-031.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-032.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-033.jpg">
                
            </div>

        <!--Fila 3 -->
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-034.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-035.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-036.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-037.jpg">
               
            </div>

        <!--Fila 4 -->
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-038.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
            </div>
            <div class="col-sm-3 mt-4 libro">
            </div>
            <div class="col-sm-3 mt-4 libro">
            </div>
    </div>
    </div>
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12 mt-5">
                <div class="row mt-5">
                    <div class="col-sm-4 mt-3">
                        <hr/>
                    </div>
                    
                    <div class="col-sm-4">
                        <p style="line-height: 120%;margin-bottom: 0%; color: #808080;"
                            class="fontMS700 text-center font-40">
                            OLEO
                        </p>
                    </div>
                    
                    <div class="col-sm-4 mt-3">
                        <hr/>
                    </div>
                    <div class="col-sm-1 mt-5"></div>
                    <div class="col-sm-10 mt-5">
                        <p class="fontMS500 text-center font-24">
                            COLECCIÓN DEL MUSEO DE BROOKLYN, NUEVA YORK, EE. UU. TOMADO DE: <br>
                            <span class="font-20" style="word-wrap: break-word;">
                            <a target="_blank" class="text-gris" href="https://colonialart.org/archives/subjects/profane-subjects/portraiture/incas-andcoyas#c1280a-1280">
                                https://colonialart.org/archives/subjects/profane-subjects/portraiture/incas-andcoyas#c1280a-1280
                            </a></span>
                        </p>
                    </div>
                    <div class="col-sm-1 mt-5"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="container">
    <div class="row ">
        <!--Fila 1 -->
            <div class="col-sm-3 mt-3 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-039.jpg">
              
            </div>
            <div class="col-sm-3 mt-3 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-040.jpg">
                
            </div>
            <div class="col-sm-3 mt-3 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-041.jpg">
                
            </div>
            <div class="col-sm-3 mt-3 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-042.jpg">
                
            </div>

        <!--Fila 2 -->
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-043.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-044.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-045.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-046.jpg">
                
            </div>

        <!--Fila 3 -->
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-047.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-048.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-049.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-050.jpg">
               
            </div>

        <!--Fila 4 -->
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-051.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
            </div>
            <div class="col-sm-3 mt-4 libro">
            </div>
            <div class="col-sm-3 mt-4 libro">
            </div>
    </div>
    </div>
</div>


<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center font-24 pi-10 pd-10 ">
                    SOBRE LA VERSIÓN IMPRESA DE RECUERDOS DE LA MONARQUÍA PERUANA, SABEMOS QUE 
                    ESTA SE PUBLICÓ EN PARÍS EN 1850. 
                    LA EDICIÓN INCLUYE 18 LITOGRAFÍAS: 16 RETRATOS DE LOS INCAS, 1 RETRATO DEL 
                    AUTOR Y 1 LÁMINA CON CUATRO ESCUDOS NOBILIARIOS. PARA LA ELABORACIÓN DE LOS 
                    RETRATOS DE LOS INCAS DE ESTA PUBLICACIÓN, EL ARTÍFICE TOMA COMO REFERENCIA 
                    EN CIERTA MEDIDA, LA ESTAMPA IDEADA POR ALONSO DE LA CUEVA. SIN EMBARGO, EL 
                    DESARROLLO DE ESTAS IMÁGENES POSEE UNA CALIDAD TÉCNICA SUPERIOR Y DE MAYOR 
                    LIBERTAD EN LA INTERPRETACIÓN DE CADA PERSONAJE. EN ESTA VERSIÓN IMPRESA DE 
                    LA OBRA, NO SE INCLUYE LA IMAGEN DE PAULLO TUPAC.

                    <br><br>
                </p>
                <p class="fontMS100 text-justify font-24  ">
                    Imágenes de: Recuerdos de la monarquía peruana, ó, Bosquejo de la historia de 
                    los incas; Recuerdos de la monarquía peruana; Bosquejo de la historia de los 
                    incas; Recuerdos de la monarquía peruana.  Sahuaraura Inca, Justo Apu, 
                    1775-aproximadamente 1853,  <br><br>
                    Librería de Rosa, Bouret y Cia, 1850.<br>
                    Disponible en: Repositorio Biblioteca Widener, Universidad de Harvard. <br>
                    ID DE REGISTRO: 990019845430203941_FHCL:923683<br>
                    <span class="font-20" style="word-wrap: break-word;">
                    <a target="_blank" class=" text-dark" href="https://curiosity.lib.harvard.edu/latin-american-pamphlet-digital-collection/catalog/43-990019845430203941_DOAKRESLIB:32870842">
                    https://curiosity.lib.harvard.edu/latin-american-pamphlet-digital-collection/catalog/43-990019845430203941_DOAKRESLIB:32870842
                    </a></span>
                </p>
            </div>
        </div>
    </div>
    <div class="container">
    <div class="row">
        <!--Fila 1 -->
            <div class="col-sm-3 mt-3 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-052.jpg">
              
            </div>
            <div class="col-sm-3 mt-3 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-053.jpg">
                
            </div>
            <div class="col-sm-3 mt-3 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-054.jpg">
                
            </div>
            <div class="col-sm-3 mt-3 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-055.jpg">
                
            </div>

        <!--Fila 2 -->
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-056.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-057.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-058.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-059.jpg">
                
            </div>

        <!--Fila 3 -->
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-060.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-061.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-062.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                    <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-063.jpg">
               
            </div>

        <!--Fila 4 -->
            <div class="col-sm-3 mt-4 libro">
                <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-064.jpg">
                
            </div>
            <div class="col-sm-3 mt-4 libro">
                <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-065.jpg">
            </div>
            <div class="col-sm-3 mt-4 libro">
                <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-066.jpg">
            </div>
            <div class="col-sm-3 mt-4 libro">
                <img width="100%"
                        src="/assets/images/micrositio/micrositio28/JUSTO-067.jpg">
            </div>
    </div>
    </div>
</div>



<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                </div>
                
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-top: 0%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            PERDIDA Y HALLAZGO
                        </p>
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS100 text-center colorPrincipal font-40">
                            DEL MANUSCRITO
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                </div>
                
                <p class="fontMS100 text-justify font-24 text-white">
                    <br><br>
                    Este invaluable manuscrito fue donado a la Biblioteca Nacional del Perú en 1850 por 
                    Juan Manuel Loza, amigo de Justo Apu Sahuaraura. Sin embargo, en el contexto de la 
                    guerra del Pacífico, esta obra fue sustraída entre los miles de ejemplares expoliados. 
                    Fue en el marco de sostenidas campañas de recuperación de libros, que nuevamente se 
                    tuvo noticias sobre su paradero. Al parecer, la obra extraviada estuvo en manos de 
                    varios coleccionistas de Chile hasta que finalmente fue comprada por un bibliófilo 
                    de Brasil, el coleccionista José Mindlin. Gracias a las gestiones de la BNP y la Cancillería, 
                    los familiares de la colección Mindlin accedieron a que esta importante obra sea repatriada, 
                    para retornar a los fondos bibliográficos de la Biblioteca Nacional del Perú donde ahora se 
                    resguarda.
                    <br><br>
                </p>
            </div>
        </div>
    </div>
</div>


<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row mt-5">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            IMPORTANCIA DE LA <br>
                            <span class="fontMS100 text-center colorPrincipal font-40">
                            DEL MANUSCRITO
                            </span>
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    
                </div>
                <p class="fontMS100 text-justify font-24">
                    <br><br>
                    La memoria nos permite reconocer y recordar a aquellas personas, tradiciones, 
                    creencias y experiencias que conforman nuestra identidad. Son esas relaciones 
                    las que nos vinculan a una comunidad, territorio o sociedad y nos otorga la 
                    capacidad de afrontar sucesos importantes con mayor sostenibilidad. 
                    En ese sentido, Justo Apu Sahuaraura sintió la necesidad de recuperar la 
                    memoria de sus antepasados, de cuyo linaje se sentía orgulloso. Ese  interés 
                    derivó en una seria investigación que le permitió ahondar en los valores que 
                    reconoció en los líderes del Tahuantinsuyo. Creando una memoria colectiva para 
                    fortalecer su presente y el futuro de sus descendientes.

                    <br><br>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoOrange">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify text-white font-24">
                            <br>
                            Justo Apu Sahuaraura buscó profundizar en el conocimiento de sus antepasados y 
                            quiso enaltecer los valores de la nobleza indígena a la cual pertenecía. Como 
                            resultado, redactó un valioso manuscrito donde, además de demostrar su pertenencia 
                            al linaje de Paullo Inca, quiso conservar para la posteridad la memoria del 
                            importante rol que jugaron cada uno Incas. Un fuerte sentimiento de pertenencia, 
                            lo incitó a resaltar el legítimo derecho de ser recordado como un eslabón más en 
                            la cadena de sucesión incaica. 
                        </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="row mt-4">
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿Sabes qué es un árbol genealógico?
                                <br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿Conoces el árbol genealógico de tu familia?
                                <br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿Tus abuelos y abuelas han 
                                nacido en el mismo lugar que 
                                tú?                                <br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </div>
                        <div class="col-sm-4">
                            <img class="bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </div>
                        <div class="col-sm-4">
                            <img class="bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿Qué recuerdos que 
                                los enorgullece han 
                                compartido contigo? 
                                <br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿Podrías entrevistar a tu papá, 
                                mamá, abuelo y abuela, y elaborar 
                                una pequeña memoria sobre sus 
                                historia o costumbres resaltantes?
                                <br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿Qué conjunto de creencias 
                                o costumbres crees que
                                compartes con la comunidad
                                en la que vives?                               <br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </div>
                        <div class="col-sm-4">
                            <img class="bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </div>
                        <div class="col-sm-4">
                            <img class="bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <p class="font-24 text-gris fontMS300">
                    <br><br>
                    BIBLIOGRAFÍA
                    <br><br>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="font-24">
                    <span class="fontMS500">Cummins, T. (1993)</span><br>
                    <span class="fontMS100Italic text-gris">
                        La representación en el siglo XVI: La Imagen colonial del Inca <br>
                        En: Mito y simbolismo en los andes. La figura y la palabra. Cuzco: 
                        Centro de Estudios Regionales Andinos “Bartolomé de las Casas”, pp. 
                        87 – 136.

                    </span>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Majluf N.(2005) 
                    </span><br>
                    <span class="fontMS100Italic text-gris">
                        De la rebelión al museo: Genealogías y retratos de los incas, 1781-1900 <br>	
                        En: Los Incas, Reyes del Perú. Colección Arte y Tesoros del Perú. Lima: 
                        Banco de Crédito, pp.253-327.

                    </span>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Stastny F. (1993)</span><br>
                    <span class="fontMS100Italic text-gris">
                        El arte de la nobleza inca y la identidad andina. <br>	
                        En: Mito y simbolismo en los andes. La figura y la palabra. Cuzco: 
                        Centro de Estudios Regionales Andinos “Bartolomé de las Casas”, 
                        pp. 137 – 156

                    </span>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="font-24">
                    <span class="fontMS500">Wuffarden L. (2005) </span><br>
                    <span class="fontMS100Italic text-gris">La descendencia real y el “renacimiento
                        inca” en el virreinato<br>
                        En: Los Incas, Reyes del Perú. Colección Arte y Tesoros del Perú. Lima: 
                        Banco de Crédito, pp.175-251.
                        
                    </span>
                </p>
                <p class="font-24">
                    <span class="fontMS500">  </span><br>
                    <span class="fontMS100Italic text-gris">Proyecto sobre las Fuentes Grabadas del Arte 
                        Colonial Español (PESSCA): https://colonialart.org/
                    </span>
                    <span class="text-gris"> </span><br>
                        <a href="https://colonialart.org/"
                            target="_blank" style="color: black;">
                            <span class="fas fa-share-square text-gris"></span>
                        </a>
                </p>
            </div>
        </div>
    </div>
</div>
<!-- Footer -->
